import angular                  from 'angular'
import uiRouter                 from 'angular-ui-router'
import 'angular-recaptcha'

import component  from './authentication.component'

let module = angular.module('authentication', [
  uiRouter,
  'vcRecaptcha'
])

.config(($stateProvider) => {
  'ngInject'
  $stateProvider
    .state('authentication', {
      url: '/authentication?email&token&huType',
      component: 'authentication',
      myRenaultForbidden: true,
      authenticatedForbidden: true
    })
})

.component('authentication', component)

.name

// Get out of the iFrame if in payment iFrame
if (window.top !== window && window.name === 'iframe_payment') {
  window.parent.postMessage({'id': 'navigate', 'url': window.location.pathname + window.location.search}, '*')
} else {
  window.addEventListener('message', function (event) {
    if (typeof event.data === 'object' && event.data !== null && event.data.id === 'navigate') {
      console.log('Reload event', event)
      window.location.href = event.data.url
    }
  })
}

export default module



// WEBPACK FOOTER //
// ./src/app/pages/authentication/index.js